"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReplayRoomTable = void 0;
const throttle_1 = __importDefault(require("lodash/throttle"));
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_query_1 = require("react-query");
const react_redux_1 = require("react-redux");
const styled_components_1 = __importDefault(require("styled-components"));
const Colors_1 = require("../../../../../Colors");
const common_1 = require("../../../../../common");
const option_1 = require("../../../../../common/option");
const GlobalStateProvider_1 = require("../../../../../GlobalStateProvider");
const server_1 = require("../../../../../server");
const account_1 = require("../../../../base/account");
const classes_1 = require("../../../../base/classes");
const DeletePopUpLayout_1 = require("../../../../base/layout/DeletePopUpLayout");
const popup_1 = require("../../../../base/popup");
const action_1 = require("../../../../menu/action");
const functions_1 = require("../../functions");
const DeleteReplayItem_1 = require("./DeleteReplayItem");
const ReplayRoomTableStyled = styled_components_1.default.div `
	display: flex;
	flex-direction: column;
	gap: ${props => (props.$isMobile ? '12px' : '24px')};
	align-items: flex-start;
	justify-content: flex-start;
	flex-shrink: 0;
	position: relative;
	width: 100%;
	flex: 1;
	height: 100%;

	.title-wrap {
		display: flex;
		flex-direction: ${props => (props.$isMobile ? 'column' : 'row')};
		align-items: center;
		gap: ${props => (props.$isMobile ? '24px' : '0')};
		/* 검색창은 항상 우측. 강사의 '선택 삭제'만 좌측에 남긴다(아래 margin-right: auto) */
		justify-content: flex-end;
		flex-shrink: 0;
		position: relative;
		width: 100%;
		${props => props.$isMobile &&
    `
			padding: 20px;
		`}
	}

	.delete-guide-wrap {
		margin-right: auto;
	}

	/* 학생 목록 제목('기출 해설' 등) — 검색창과 같은 줄, 좌측. 모바일은 title-wrap 이 세로 배치라 위에 놓인다 */
	.list-title {
		margin-right: auto;
		color: var(--color-black, #101010);
		font-family: var(--h3-font-family, 'Noto Sans KR', sans-serif);
		/* 같은 화면 위 섹션의 예약 강의 제목(ReservationTitle .class-reservation)과 동일한 크기·줄높이 */
		${props => props.$isDesktop
    ? 'font-size: var(--h3-font-size, 24px); line-height: var(--h3-line-height, 36px);'
    : props.$isTablet
        ? 'font-size: var(--h3-font-size, 18px); line-height: 150%;'
        : 'font-size: var(--h3-font-size, 16px); line-height: 150%;'}
		font-weight: var(--h3-font-weight, 700);
		white-space: nowrap;
	}

	/* 검색창 래퍼 — 예약 강의 표와 같은 구조(.active-bar). 모바일은 전역 규칙(.mobile .active-bar { width: 99% })이
	   적용돼 검색창 폭이 위 섹션과 정확히 같아진다 */
	.title-wrap .active-bar {
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}

	.mobile_txt {
		display: flex;
		align-items: center;
		justify-content: flex-start;
		gap: ${props => (props.$isMobile ? '5px' : '12px')};

		span {
			color: var(--color-black, #101010);
			text-align: left;
			font-family: 'Noto Sans KR', sans-serif;
			font-size: 12px;
			line-height: 150%;
			letter-spacing: -0.02em;
			font-weight: 400;
			position: relative;
			text-overflow: ellipsis;
			overflow: hidden;
		}

		.bold_txt {
			font-weight: 700;
		}

		.grey_txt {
			color: var(--color-grey-l, #83868a);
		}
	}

	.live-list-005 {
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: center;
		justify-content: flex-start;
		flex: 1;
		position: relative;
		${props => props.$isMobile &&
    `
			padding: 12px 20px;
			height: auto;
			.check-btn {
				border-style: solid;
				border-color: var(--color-silver, #f3f4f8);
				border-width: 0px 0px 1px 0px;
				padding: 0px 0px 8px 0px;
			}
		`}

		.scroll-content {
			display: flex;
			flex-direction: column;
		}

		.body-item {
			overflow: hidden;
		}

		.table-header {
			background: var(--color-silver, #f3f4f8);
			border-radius: 40px;
			padding: ${props => (props.$isTablet ? '12px 20px' : '6px 28px')};
			display: flex;
			flex-direction: row;
			gap: ${props => (props.$isTablet ? '12px' : '28px')};
			align-items: center;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;

			p {
				color: var(--color-grey, #666666);
				text-align: left;
				font-family: var(--b3-font-family, 'Noto Sans KR', sans-serif);
				font-size: ${props => props.$isTablet ? 'var(--b4-font-size, 14px)' : 'var(--b3-font-size, 16px)'};
				line-height: ${props => (props.$isTablet ? '150%' : 'var(--b3-line-height, 32px)')};
				letter-spacing: var(--b3-letter-spacing, -0.02em);
				font-weight: var(--b3-font-weight, 400);
				position: relative;
			}
		}

		.item {
			${props => props.$isMobile
    ? `
                        border-style: solid;
                        border-color: var(--color-silver, #f3f4f8);
                        border-width: 0px 0px 1px 0px;
                        padding: 12px 0px 12px 0px;
                        display: flex;
                        flex-direction: column;
                        gap: 4px;
                        align-items: flex-start;
                        justify-content: center;
                        align-self: stretch;
                        flex-shrink: 0;
                        position: relative;
            `
    : `
                    border-style: solid;
                    border-color: var(--color-silver, #f3f4f8);
                    border-width: 0px 0px 1px 0px;
                    padding: ${props.$isTablet ? '24px 20px' : '20px 28px'};
                    display: flex;
                    flex-direction: row;
                    gap: ${props.$isTablet ? '12px' : '28px'};
                    align-items: center;
                    justify-content: flex-start;
                    align-self: stretch;
                    flex-shrink: 0;
                    position: relative;`}
			${props => props.$isTablet &&
    `
				.body-item {
					p {
						font-size: var(--b4-font-size, 14px);
						line-height: 150%;
					}
				}	
			`}
		}
	}

	/* 제목은 클릭(학생: 재생 팝업 / 강사: 상세)이라 밑줄로 강조 — 행 어디를 눌러도 동작하지만 눈에 띄는 진입점을 준다 */
	/* 수강 여부 — 수강은 기본색, 미수강은 흐리게 */
	.not-watched {
		color: var(--color-grey-l, #83868a);
	}

	.replay-title {
		text-decoration: underline;
		text-decoration-color: var(--color-grey-w, #b6bac0);
		text-underline-offset: 3px;
		cursor: pointer;

		&:hover {
			text-decoration-color: var(--color-black, #101010);
		}
	}

	.live-replay-005 {
		.scroll-content,
		.table-item-wrap {
			display: flex;
			flex-direction: row;
			gap: ${props => (props.$isMobile ? '14px' : props.$isTablet ? '16px' : '20px')};
		}
		.item {
			max-width: 300px;
			flex: 1;
		}
	}
`;
exports.ReplayRoomTable = react_1.default.memo(({ isHome, round, year, month, headerTitle, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const tableRef = (0, react_1.useRef)(null);
    const dispatch = (0, react_redux_1.useDispatch)();
    const { isMobile, isTablet, isDesktop } = (0, GlobalStateProvider_1.useGlobalState)();
    const access_token = (0, react_redux_1.useSelector)((state) => (0, account_1.getAccessToken)(state));
    const isTeacher = (0, react_redux_1.useSelector)((state) => (0, account_1.getIsTeacher)(state));
    const userId = (0, react_redux_1.useSelector)((state) => (0, account_1.getUserId)(state));
    const classes_data = (0, react_redux_1.useSelector)((state) => (0, classes_1.getClasses)(state));
    // 행 단위 리스트(2026-09 운영 요청): 홈 위젯(isHome)만 카드, 다시보기 메뉴는 학생·강사 모두 표.
    // 컬럼은 권한별 — 학생: No/제목/등록 파일/등록일, 강사: No/제목/공개 설정/등록 파일/등록일/관리
    const isTable = (0, react_1.useMemo)(() => !isHome, [isHome]);
    const historyStore = (0, GlobalStateProvider_1.useHistoryStore)();
    const [previousPageState, setPreviousPageState] = (0, react_1.useState)(); // 이전 페이지의 상태를 저장
    const [previousSearchContent, setPreviousSearchContent] = (0, react_1.useState)(''); // 이전 검색어를 저장
    // 학생이 스트리밍을 선택한 경우
    const [choiceStreaming, setChoiceStreaming] = react_1.default.useState();
    const [testData, setTestData] = react_1.default.useState([]);
    const [page, setPage] = react_1.default.useState(0);
    const [totalCount, setTotalCount] = react_1.default.useState(0);
    const [count, setCount] = react_1.default.useState(0);
    const [checkedList, setCheckedList] = react_1.default.useState([]);
    const [searchOption, setSearchOption] = react_1.default.useState({});
    const { headTitleList, tableReadDataKeys } = react_1.default.useMemo(() => {
        const headTitleList = isMobile || !isTable
            ? []
            : isTeacher
                ? [
                    { title: 'live_title', label: '제목', space: 3, sort: false },
                    { title: 'disclosure', label: '공개 설정', space: 1, sort: false },
                    { title: 'fileName', label: '등록 파일', space: 2, sort: false },
                    { title: 'creation_time', label: '등록일', space: 2, sort: false },
                    { title: 'etc', label: '관리', space: 1, sort: false },
                ]
                : [
                    { title: 'live_title', label: '제목', space: 3, sort: false },
                    { title: 'watchStatus', label: '수강 여부', space: 1, sort: false },
                    { title: 'lectureTime', label: '강의시간', space: 1, sort: false },
                    { title: 'lastWatchedAt', label: '최근 수강일', space: 2, sort: false },
                ];
        const tableReadDataKeys = !isTable
            ? []
            : isMobile
                ? isTeacher
                    ? [
                        { title: 'title', space: 1 },
                        { title: 'fileName', space: 1 },
                        { title: 'etc', space: 1 },
                    ]
                    : [
                        { title: 'title', space: 1 },
                        { title: 'watchStatus', space: 1 },
                        { title: 'lectureTime', space: 1 },
                        { title: 'lastWatchedAt', space: 1 },
                    ]
                : isTeacher
                    ? [
                        { title: 'title', space: 3 },
                        { title: 'status', space: 1 },
                        { title: 'fileName', space: 2 },
                        { title: 'creation_time', space: 2 },
                        { title: 'etc', space: 1 },
                    ]
                    : [
                        { title: 'title', space: 3 },
                        { title: 'watchStatus', space: 1 },
                        { title: 'lectureTime', space: 1 },
                        { title: 'lastWatchedAt', space: 2 },
                    ];
        return { headTitleList, tableReadDataKeys };
    }, [isTable, isMobile, isTeacher]);
    const deleteReplayMutation = (0, react_query_1.useMutation)(server_1.deleteReplay);
    // 학생 목록의 '수강 여부 / 최근 수강일' 원본 — 본인 기준 다시보기 시청 현황(replay-report).
    // 페이지와 무관하게 replay_id 로 맞춰야 해서 넉넉히 받아 맵으로 만든다.
    const isStudentList = !isHome && !isTeacher;
    const { data: reportData, refetch: refetchReport } = (0, server_1.useReplayReportList)({
        id: userId,
        offset: 0,
        limit: 200,
    });
    react_1.default.useEffect(() => {
        if (isStudentList && userId)
            refetchReport();
    }, [isStudentList, userId]);
    const reportMap = react_1.default.useMemo(() => {
        const map = new Map();
        (reportData?.items ?? []).forEach(report => {
            if (report?.replay_id)
                map.set(report.replay_id, report);
        });
        return map;
    }, [reportData]);
    /**
     * 강의시간 — 다시보기 응답 medias[].duration(서버 패치 2026-09-28) 합계.
     * 서버가 영상별 길이를 "분 단위 올림"(ceil(ms/60000))으로 내려준다(dev 40건 실측 일치) — 요청 규칙과 동일.
     * 영상이 여럿이면 각 영상의 올림값을 더하므로 실제 합계의 올림보다 최대 (영상 수-1)분 클 수 있다.
     * 길이가 없으면(0) '-'. 학생 토큰으로도 이 값이 오므로 별도 미디어 서비스 조회는 필요 없다.
     */
    const formatLectureTime = react_1.default.useCallback((item) => {
        const totalMinutes = (item.medias ?? []).reduce((sum, media) => {
            const value = media?.duration;
            return sum + (typeof value === 'number' && value > 0 ? value : 0);
        }, 0);
        return totalMinutes > 0 ? `${totalMinutes}분` : '-';
    }, []);
    const updateState = () => {
        if (tableRef.current) {
            const { offsetWidth } = tableRef.current;
            const count = Math.floor(offsetWidth / (isDesktop ? 300 : 252));
            setCount(count);
        }
    };
    (0, react_1.useEffect)(() => {
        if (isTeacher) {
            // 이전 페이지의 상태를 가져와서 적용
            const previousPage = historyStore.getRecentPageHistory('replayListPage');
            if (previousPage) {
                // 이전 페이지의 상태를 적용
                setSearchOption(previousPage.searchOption);
                setPreviousSearchContent(previousPage.searchOption[Object.keys(previousPage.searchOption)[0]]);
                setPage(previousPage.prePage);
                setPreviousPageState(previousPage);
            }
            historyStore.clearHistoryForPage('replayListPage');
        }
    }, [isTeacher]);
    (0, react_1.useEffect)(() => {
        if (!isTable) {
            updateState();
            window.addEventListener('resize', updateState);
            APP.eventManager.subscribe('UPDATE_REPLAY_PAGE', handlerMoreData);
        }
        else {
            setCount(10);
            window.removeEventListener('resize', updateState);
            APP.eventManager.unsubscribe('UPDATE_REPLAY_PAGE', handlerMoreData);
        }
        return () => {
            window.removeEventListener('resize', updateState);
            APP.eventManager.unsubscribe('UPDATE_REPLAY_PAGE', handlerMoreData);
        };
    }, [isTable]);
    //홈화면 리스트 갱신
    (0, react_1.useEffect)(() => {
        if (!isTable)
            APP.eventManager.publish('SEND_REVIEW_LIST', { totalCount, count, page });
    }, [isTable, totalCount, count, page, classes_data]);
    const { data, refetch } = (0, server_1.useReplayList)({
        ...(previousPageState
            ? previousPageState.preItems
            : {
                ...searchOption,
                offset: page === 0 ? 0 : page * count,
                limit: count,
                round,
                year,
                month,
                orderby: ['creation_time DESC'],
            }),
    });
    const refetchList = (0, throttle_1.default)(() => {
        refetch();
    }, 1000, { leading: true, trailing: false });
    /** 다시보기 리스트 창에서 round, year, month 값이 변경되며
        리스트 갱신 오류가 생기는 것 같아 홈 화면과분리,
        학생 강의 다시보기가 제대로 동작하지 않아 isTeacher 추가 **/
    (0, react_1.useEffect)(() => {
        if (isHome || !isTeacher) {
            refetchList();
        }
    }, [round, year, month, page, count, searchOption, isHome, isTeacher]);
    (0, react_1.useEffect)(() => {
        if (!isHome && isTeacher) {
            refetchList();
        }
    }, [page, count, searchOption, isHome, isTeacher]);
    (0, react_1.useEffect)(() => {
        if (choiceStreaming) {
            let popup;
            if (popup && !popup.closed) {
                popup.location.href = '/player/' + choiceStreaming.id;
            }
            else {
                popup = window.open('/player/' + choiceStreaming.id, 'popupPage', 'directories=no,titlebar=no,toolbar=no,status=no,menubar=no,location=yes,width=1920,height=964,scrollbars=yes');
            }
            popup.localStorage.removeItem('access_token');
            popup.localStorage.setItem('access_token', access_token);
            if (popup) {
                popup.onload = function () {
                    popup = null;
                    setChoiceStreaming(undefined);
                    return;
                };
            }
            setChoiceStreaming(undefined);
        }
    }, [choiceStreaming]);
    // 이벤트 등록 - 리스트 갱신
    (0, react_1.useEffect)(() => {
        APP.eventManager.subscribe('REFRESH_REPLAY_LIST', refetchList);
        return () => {
            APP.eventManager.unsubscribe('REFRESH_REPLAY_LIST', refetchList);
        };
    }, []);
    (0, react_1.useEffect)(() => {
        if (data) {
            const { items, total_count } = data;
            //이전 페이지 저장된 기록 초기화
            if (previousPageState) {
                setPreviousPageState(undefined);
            }
            if (total_count > 0) {
                setTestData(items);
                setTotalCount(isHome ? Math.min(5, total_count) : total_count);
                return;
            }
        }
        setTestData([]);
        setTotalCount(0);
    }, [data]);
    // 상세 페이지로 이동
    const handlerDetailPage = (id, isModify = false) => {
        if (isHome) {
            dispatch((0, action_1.updateMenu)('liveRoom', { menu: 'replay', detail: isModify ? 'modify' : 'detail' }, id));
        }
        APP.eventManager.publish('UPDATE_DETAIL_MENU', {
            menuDetail: isModify ? 'modify' : 'detail',
            id,
        });
    };
    const handlerMoreData = (page) => {
        setPage(page);
    };
    const handlerSelectItem = (item) => {
        if (isTeacher) {
            const historyItem = {
                preItems: {
                    ...searchOption,
                    offset: page === 0 ? 0 : page * count,
                    limit: count,
                    round,
                    year,
                    month,
                    orderby: ['creation_time DESC'],
                },
                prePage: page,
                searchOption: searchOption,
                pageName: 'replayListPage',
            };
            historyStore.pushHistory(historyItem);
            handlerDetailPage(item.id, false);
        }
        else {
            setChoiceStreaming(item);
        }
    };
    const onDelete = async (id) => {
        try {
            APP.eventManager.publish('SHOW_LOADING', true);
            await deleteReplayMutation.mutateAsync(id);
            APP.eventManager.publish('UPDATE_DETAIL_MENU', {
                menuDetail: 'list',
                id: undefined,
            });
            APP.eventManager.publish('REFETCH_QNA_LIST');
            console.log('1');
            refetchList();
        }
        catch (error) {
            alert(error);
        }
        finally {
            APP.eventManager.publish('SHOW_LOADING', false);
        }
    };
    // 하나 삭제
    const handlerOneDel = async (id) => {
        APP.eventManager.publish(popup_1.TOGGLE_POPUP, {
            component: DeletePopUpLayout_1.DeletePopUpLayout,
            componentProps: {
                deleteContent: t('assignment.delteInto', { count: 1 }),
                onDelete: () => onDelete(id),
            },
            width: 639,
            title: t(`conference.replayDelete`),
            isFit: true,
        });
    };
    const handlerFilterList = (filter) => {
        setSearchOption(filter);
    };
    const renderGuidItem = (0, react_1.useMemo)(() => react_1.default.createElement(DeleteReplayItem_1.DeleteReplayItem, { isOneDel: false, deleteList: checkedList, menu: "replay" }), [checkedList]);
    // Title 가져오기
    const renderTitle = (0, react_1.useMemo)(() => {
        return (react_1.default.createElement("div", { className: "title-wrap" },
            headerTitle && react_1.default.createElement("div", { className: "list-title" }, headerTitle),
            !isMobile && isTeacher && (react_1.default.createElement("div", { className: "delete-guide-wrap" }, renderGuidItem)),
            react_1.default.createElement("div", { className: "active-bar" },
                react_1.default.createElement(common_1.SearchBar, { className: `${!isMobile ? 'search-bar-qna' : 'search-bar-mobile'}`, handlerFilterList: handlerFilterList, filterData: "title", defaultSearchContent: previousSearchContent }))));
    }, [setSearchOption, checkedList, headerTitle]);
    const renderEmpty = (0, react_1.useMemo)(() => react_1.default.createElement(option_1.EmptyTable, { title: "conference.replayEmptyContent" }), [totalCount]);
    // Item 가져오기
    const renderItem = (item, styles) => {
        if (isTable) {
            return tableReadDataKeys.map((headItem, index) => {
                const isTitle = headItem.title === 'title';
                const isEtc = headItem.title === 'etc';
                const isCreationTime = headItem.title === 'creation_time';
                const media = item.medias.length > 0 ? item.medias[0] : null;
                // 학생 컬럼(수강 여부 / 강의시간 / 최근 수강일) — 본인 시청 현황 기준
                const report = reportMap.get(item.id);
                const watchedMs = report?.total_streaming_play_duration ?? 0;
                const watchStatusText = watchedMs > 0 ? '수강' : '미수강';
                const lectureTimeText = formatLectureTime(item);
                const lastWatchedText = report?.last_streaming_play_time
                    ? (0, moment_1.default)(report.last_streaming_play_time).format('YYYY-MM-DD, HH:mm')
                    : '-';
                const mobileContent = isTitle ? (react_1.default.createElement("span", { className: "bold_txt replay-title" }, item.title)) : headItem.title === 'fileName' ? (react_1.default.createElement("span", { className: "grey_txt" }, media?.name || '-')) : isCreationTime ? (react_1.default.createElement("span", { className: "grey_txt" }, (0, moment_1.default)(item.creation_time).format('YYYY-MM-DD, HH:mm'))) : headItem.title === 'watchStatus' ? (react_1.default.createElement("span", { className: `grey_txt ${watchedMs > 0 ? 'watched' : ''}` }, watchStatusText)) : headItem.title === 'lectureTime' ? (react_1.default.createElement("span", { className: "grey_txt" }, lectureTimeText)) : headItem.title === 'lastWatchedAt' ? (react_1.default.createElement("span", { className: "grey_txt" }, lastWatchedText)) : isEtc ? (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("span", { className: "grey_txt" }, media ? (0, functions_1.formatFileSize)(media?.size) : '-'),
                    react_1.default.createElement("span", { className: "grey_txt" }, t(`conference.${item.status}`)),
                    react_1.default.createElement("span", { className: "grey_txt" }, (0, moment_1.default)(item.creation_time).format('YYYY-MM-DD, HH:mm')))) : (react_1.default.createElement("span", null, item[headItem.title]));
                const desktopContent = isCreationTime ? (react_1.default.createElement("p", { className: "overText2" }, (0, moment_1.default)(item.creation_time).format('YYYY-MM-DD, HH:mm'))) : headItem.title === 'watchStatus' ? (react_1.default.createElement("p", { className: `overText2 ${watchedMs > 0 ? 'watched' : 'not-watched'}` }, watchStatusText)) : headItem.title === 'lectureTime' ? (react_1.default.createElement("p", { className: "overText2" }, lectureTimeText)) : headItem.title === 'lastWatchedAt' ? (react_1.default.createElement("p", { className: "overText2" }, lastWatchedText)) : headItem.title === 'fileName' ? (react_1.default.createElement("p", { className: "overText2" }, media?.name || '-')) : headItem.title === 'size' ? (react_1.default.createElement("p", { className: "overText2" }, media ? (0, functions_1.formatFileSize)(media?.size) : '-')) : headItem.title === 'status' ? (react_1.default.createElement("p", { className: "overText2" }, t(`conference.${item.status}`))) : isEtc ? (react_1.default.createElement("div", { className: "flex row", style: { gap: 10 } },
                    react_1.default.createElement(common_1.Button, { option: {
                            buttonAfterIcon: {
                                show: true,
                                name: 'edit',
                                color: Colors_1.Colors.dark_blue,
                                size: 20,
                            },
                        }, onClick: e => {
                            e.stopPropagation();
                            handlerDetailPage(item.id, true);
                        } }),
                    react_1.default.createElement(common_1.Button, { option: {
                            buttonAfterIcon: {
                                show: true,
                                name: 'delete',
                                color: Colors_1.Colors.pink,
                                size: 20,
                            },
                        }, onClick: e => {
                            e.stopPropagation();
                            handlerOneDel(item.id);
                        } }))) : isTitle ? (react_1.default.createElement("p", { className: "overText2 replay-title", title: item.title }, item.title)) : (react_1.default.createElement("p", { className: "overText2" }, item[headItem.title]));
                return (react_1.default.createElement("div", { key: index, className: `body-item ${isMobile ? 'mobile_txt' : ''}`, style: {
                        flex: headItem.space,
                        cursor: 'pointer',
                    } }, isMobile ? mobileContent : desktopContent));
            });
        }
        else {
            return (react_1.default.createElement("div", { className: "review-class-list", key: item.id },
                react_1.default.createElement("div", { className: "new" },
                    react_1.default.createElement("div", { className: "text" }, "new")),
                react_1.default.createElement("div", { className: "class-title overText2" }, item.title),
                react_1.default.createElement("div", { className: "regist-date-wrapper" },
                    react_1.default.createElement("div", { className: "regist-date" }, "\uB4F1\uB85D\uC77C\uC790"),
                    react_1.default.createElement("div", { className: "regist-time" }, (0, moment_1.default)(item.creation_time).format('YYYY-MM-DD, HH:mm')))));
        }
    };
    return (react_1.default.createElement(ReplayRoomTableStyled, { ref: tableRef, "$isMobile": isMobile, "$isTablet": isTablet, "$isDesktop": isDesktop, "$isTeacher": isTeacher },
        react_1.default.createElement(common_1.Table, { className: isTable ? 'live-list-005' : 'live-replay-005', showIndex: !isTable || isMobile ? false : true, indexOrder: "desc", showCheckBox: isTable && isTeacher, isInfinite: false, headTitleList: headTitleList, data: testData, page: page, totalCount: totalCount, showCount: count, noPaging: isTable ? false : true, renderTitle: isTable && renderTitle, renderEmpty: totalCount === 0 && renderEmpty, renderItem: renderItem, renderGuidItem: isTeacher && renderGuidItem, 
            // 학생 목록은 같은 화면의 예약 강의 표(ReservationTable)와 동일하게 Table 안쪽 20px 패딩 없이 —
            // 태블릿에서 제목·검색창·표가 위 섹션보다 20px 더 안으로 밀리던 원인
            padding: isTeacher, handlerCheckList: setCheckedList, handlerMoreData: handlerMoreData, handlerSelectItem: handlerSelectItem, forceShowheader: !isTable || isMobile ? false : true })));
});
